import React from "react";
import MainCategories from "../components/Categories/MainCategories";
import Sidebar from "../components/sidebar";
import Header from "./../components/Header";

const CategoriesScreen = () => {
  return (
    <>
      <Sidebar />
      <main className="main-wrap">
        <Header />
        <MainCategories />
      </main>
    </>
  );
};

export default CategoriesScreen;
